import { logError } from '@/utils/error-handling';

// Storage helper for web (using localStorage as AsyncStorage replacement)
export const storage = {
  getItem: async (key: string): Promise<string | null> => {
    if (typeof window === 'undefined') return null;
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      logError(error, 'storage.getItem', true);
      return null;
    }
  },
  setItem: async (key: string, value: string): Promise<void> => {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      logError(error, 'storage.setItem', true);
    }
  },
  removeItem: async (key: string): Promise<void> => {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      logError(error, 'storage.removeItem', true);
    }
  },
  getAllKeys: async (): Promise<string[]> => {
    if (typeof window === 'undefined') return [];
    try {
      return Object.keys(window.localStorage);
    } catch (error) {
      logError(error, 'storage.getAllKeys', true);
      return [];
    }
  },
  multiGet: async (keys: string[]): Promise<[string, string | null][]> => {
    if (typeof window === 'undefined') return keys.map(k => [k, null]);
    try {
      return keys.map(key => [key, window.localStorage.getItem(key)]);
    } catch (error) {
      logError(error, 'storage.multiGet', true);
      return keys.map(k => [k, null]);
    }
  },
  multiSet: async (keyValuePairs: [string, string][]): Promise<void> => {
    if (typeof window === 'undefined') return;
    try {
      keyValuePairs.forEach(([key, value]) => {
        window.localStorage.setItem(key, value);
      });
    } catch (error) {
      logError(error, 'storage.multiSet', true);
    }
  },
  multiRemove: async (keys: string[]): Promise<void> => {
    if (typeof window === 'undefined') return;
    try {
      keys.forEach(key => {
        window.localStorage.removeItem(key);
      });
    } catch (error) {
      logError(error, 'storage.multiRemove', true);
    }
  },
};

